module.exports = __webpack_public_path__ + "static/media/damages.873d4c77.svg";